import { useRoute } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { selectHeaderConfig } from '@reducers/details';
import i18n from 'i18n-js';
import { useGetHeaderConfig } from './useGetHeaderConfig';

export const useTitle = () => {
  const route = useRoute();
  const headerConfig = useGetHeaderConfig();

  const title = {
    batch: route.params?.batchNumber ?? headerConfig.batch,
    ncFile: route.params?.ncFileName ?? headerConfig.ncFile,
    part: route.params?.partName ?? headerConfig.part?.name,
    tool: route.params?.toolName ?? headerConfig.tools,
    job: route.params?.productionOrderNumber ?? headerConfig.job,
    productionOrder: route.params?.productionOrderNumber ?? headerConfig.productionOrder,
  };

  const commonPart = {
    batch: i18n.t('Batch'),
    ncFile: i18n.t('NC File'),
    part: i18n.t('Part'),
    tool: i18n.t('Tool'),
    job: i18n.t('Job'),
    productionOrder: i18n.t('Production Order'),
  };

  return {
    batch: title.batch ? `${commonPart.batch} ${title.batch}` : `${commonPart.batch}`,
    ncFile: title.ncFile ? `${commonPart.ncFile} ${title.ncFile}` : `${commonPart.ncFile}`,
    part: title.part ? `${commonPart.part} ${title.part}` : `${commonPart.part}`,
    tool: title.tool ? `${commonPart.tool} ${title.tool}` : `${commonPart.tool}`,
    job: title.job ? `${commonPart.job} ${title.job}` : `${commonPart.job}`,
    productionOrder: title.productionOrder ? `${commonPart.productionOrder} ${title.productionOrder}` : `${commonPart.productionOrder}`,
  };
};
